import { Badge, Button, useMediaQuery } from '@mui/material'
import { ShoppingCartOutlined } from '@mui/icons-material'
import { useCart, useCurrentStore, useOrdering } from 'hooks'
import { useTheme } from '@mui/material/styles'
import { getOrderItemCount } from 'services'
import { KSmallIconButton } from 'components/core/KButton'

export const CartButton = () => {
  const theme = useTheme()
  const { order } = useOrdering()
  const { showCart } = useCart()
  const { formatCurrency } = useCurrentStore()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  if (!order) return null

  const itemCount = getOrderItemCount(order)

  if (isMobile) {
    return (
      <Badge
        badgeContent={itemCount}
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: theme.palette.primary[200],
            color: theme.palette.primary.main,
            minWidth: '18px',
            height: '18px',
            padding: 0,
            borderRadius: '50%',
          },
        }}
      >
        <KSmallIconButton onClick={showCart}>
          <ShoppingCartOutlined />
        </KSmallIconButton>
      </Badge>
    )
  }

  return (
    <Badge
      badgeContent={itemCount}
      color="secondary"
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.success.main,
          border: `1px solid ${theme.palette.success.main}`,
        },
      }}
    >
      <Button
        onClick={showCart}
        variant="contained"
        size="large"
        startIcon={<ShoppingCartOutlined />}
        sx={{
          ...theme.typography.body1,
          backgroundColor: theme.palette.success.main,
          '& .MuiButton-startIcon': {
            marginRight: 2,
          },
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
            backgroundColor: theme.palette.success['900'],
          },
        }}
      >
        {formatCurrency((order.total ?? 0) - (order.tip ?? 0))}
      </Button>
    </Badge>
  )
}
